













import { Component, Vue } from 'vue-property-decorator';
import { BenefitTextType, PremiumBenefit } from '../PremiumBenefit.vue';
import PremiumCard from '../PremiumCard.vue';

@Component({
  components: { PremiumCard },
})
export default class PremimumCardFree extends Vue {
  benefits: PremiumBenefit[] = [
    {
      isBenfit: false,
      texts: [
        {
          type: BenefitTextType.Normal,
          text: '2x download PDF Set Latihan Sahaja',
        },
      ],
    },
    {
      isBenfit: false,
      texts: [
        {
          type: BenefitTextType.Normal,
          text: '2x Bina Latihan Sahaja',
        },
      ],
    },
    {
      isBenfit: false,
      texts: [
        {
          type: BenefitTextType.Normal,
          text: 'Limited Bank Soalan',
        },
      ],
    },
    {
      isBenfit: false,
      texts: [
        {
          type: BenefitTextType.Normal,
          text: 'Ada Ads',
        },
      ],
    },
  ];

  onSubscriptionSubmit() {
    this.$sendMpEvent({ event: this.$mp_value.SubscriptionFreeClick });

    this.$router.push({
      name: 'browse',
    });
  }
}
